import { Turbo } from "@hotwired/turbo-rails"

Turbo.config.forms.confirm = (message) => {
  return new Promise((resolve) => {
    const modal = document.getElementById("confirmModal")
    const messageEl = document.getElementById("confirmModalMessage")
    const acceptBtn = document.getElementById("confirmModalAccept")

    messageEl.textContent = message

    const bsModal = new bootstrap.Modal(modal)

    const handleAccept = () => {
      cleanup()
      bsModal.hide()
      resolve(true)
    }

    const handleDismiss = () => {
      cleanup()
      resolve(false)
    }

    const cleanup = () => {
      acceptBtn.removeEventListener("click", handleAccept)
      modal.removeEventListener("hidden.bs.modal", handleDismiss)
    }

    acceptBtn.addEventListener("click", handleAccept, { once: true })
    modal.addEventListener("hidden.bs.modal", handleDismiss, { once: true })

    bsModal.show()
  })
}
